<template>
  <b-modal
    id="createFolder"
    hide-footer
    no-close-on-backdrop
    @show="resetFields"
    modal-class="modern-modal"
    size="lg"
  >
    <template v-slot:modal-title>
      <div class="modal-title-modern">
        <i class="fas fa-folder-plus mr-2"></i>
        Criar Nova Pasta
      </div>
    </template>

    <div class="modal-content-modern">
      <div class="form-sections">
        <!-- Seção: Informações Básicas -->
        <div class="form-section">
          <div class="section-header">
            <h4 class="section-title">
              <i class="fas fa-info-circle mr-2"></i>
              Informações Básicas
            </h4>
          </div>
          <div class="section-content">
            <div class="form-group">
              <LabelRequiredField label="Nome da Pasta" />
              <div class="input-wrapper">
                <i class="fas fa-folder input-icon"></i>
                <input
                  type="text"
                  v-model="name"
                  class="modern-input"
                  placeholder="Digite o nome da pasta"
                  ref="nameInput"
                />
              </div>
            </div>
          </div>
        </div>

        <!-- Seção: Tipo de Pasta -->
        <div v-if="!selected_resident_id" class="form-section">
          <div class="section-header">
            <h4 class="section-title">
              <i class="fas fa-layer-group mr-2"></i>
              Tipo de Pasta
            </h4>
          </div>
          <div class="section-content">
            <div class="toggle-group">
              <button
                type="button"
                :class="['toggle-btn', { active: type_folder == 'EMPRESA' }]"
                @click="type_folder = 'EMPRESA'"
              >
                <i class="fas fa-building mr-2"></i>
                <span>Empresa</span>
              </button>
              <button
                type="button"
                :class="['toggle-btn', { active: type_folder == 'RESIDENTE' }]"
                @click="type_folder = 'RESIDENTE'"
              >
                <i class="fas fa-user mr-2"></i>
                <span>Residente</span>
              </button>
            </div>
          </div>
        </div>

        <!-- Seção: Seleção de Residente -->
        <div v-if="type_folder == 'RESIDENTE'" class="form-section">
          <div class="section-header">
            <h4 class="section-title">
              <i class="fas fa-users mr-2"></i>
              Selecionar Residente
            </h4>
          </div>
          <div class="section-content">
            <div class="form-group">
              <LabelRequiredField label="Residente" />
              <div class="select-wrapper">
                <v-select
                  v-model="resident_id"
                  :items="residents"
                  item-text="name"
                  item-value="id"
                  clearable
                  ref="residentSelect"
                  outlined
                  hide-details
                  class="modern-select"
                  placeholder="Selecione um residente"
                />
              </div>
            </div>
          </div>
        </div>

        <!-- Seção: Privacidade -->
        <div class="form-section">
          <div class="section-header">
            <h4 class="section-title">
              <i class="fas fa-shield-alt mr-2"></i>
              Configurações de Privacidade
            </h4>
          </div>
          <div class="section-content">
            <div class="toggle-group">
              <button
                type="button"
                :class="[
                  'toggle-btn privacy-btn',
                  { active: public_folder == 1 },
                ]"
                @click="public_folder = 1"
              >
                <i class="fas fa-globe mr-2"></i>
                <span>Pública</span>
              </button>
              <button
                type="button"
                :class="[
                  'toggle-btn privacy-btn',
                  { active: public_folder == 0 },
                ]"
                @click="public_folder = 0"
              >
                <i class="fas fa-lock mr-2"></i>
                <span>Privada</span>
              </button>
            </div>
          </div>
        </div>

        <!-- Seção: Tipo de vínculo -->
        <div v-if="public_folder == 0" class="form-section">
          <div class="form-section">
            <div class="section-header">
              <h4 class="section-title">Vincular por:</h4>
            </div>
            <div class="section-content">
              <div class="toggle-group">
                <button
                  type="button"
                  :class="[
                    'toggle-btn privacy-btn',
                    { active: link_folder == 'USER' },
                  ]"
                  @click="link_folder = 'USER'"
                >
                  <i class="fas fa-user mr-2"></i>
                  <span>Usuário</span>
                </button>
                <button
                  type="button"
                  :class="[
                    'toggle-btn privacy-btn',
                    { active: link_folder == 'PROFILE' },
                  ]"
                  @click="link_folder = 'PROFILE'"
                >
                  <i class="fas fa-users mr-2"></i>
                  <span>Perfil</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Seção: Usuários com Acesso -->
        <div
          v-if="public_folder == 0 && link_folder == 'USER'"
          class="form-section"
        >
          <div class="section-header">
            <h4 class="section-title">
              <i class="fas fa-user-check mr-2"></i>
              Controle de Acesso por Usuário
            </h4>
          </div>
          <div class="section-content">
            <div class="form-group">
              <LabelRequiredField label="Usuários com Acesso" />
              <div class="select-wrapper">
                <v-select
                  v-model="users_ids"
                  :items="users"
                  item-text="name"
                  item-value="id"
                  multiple
                  clearable
                  ref="userSelect"
                  outlined
                  hide-details
                  class="modern-select"
                  placeholder="Selecione os usuários"
                  @change="closeSelectUser"
                />
              </div>
              <div class="form-hint">
                <i class="fas fa-info-circle mr-1"></i>
                Selecione quais usuários poderão visualizar esta pasta
              </div>
            </div>
          </div>
        </div>

        <!-- Seção: Perfis com Acesso -->
        <div
          v-if="public_folder == 0 && link_folder == 'PROFILE'"
          class="form-section"
        >
          <div class="section-header">
            <h4 class="section-title">
              <i class="fas fa-user-check mr-2"></i>
              Controle de Acesso por Perfil de Usuário
            </h4>
          </div>
          <div class="section-content">
            <div class="form-group">
              <LabelRequiredField label="Perfis com Acesso" />
              <div class="select-wrapper">
                <v-select
                  v-model="profiles_ids"
                  :items="profiles"
                  item-text="name"
                  item-value="id"
                  multiple
                  clearable
                  ref="profileSelect"
                  outlined
                  hide-details
                  class="modern-select"
                  placeholder="Selecione os perfis"
                  @change="closeSelectProfile"
                />
              </div>
              <div class="form-hint">
                <i class="fas fa-info-circle mr-1"></i>
                Selecione quais usuários poderão visualizar esta pasta
              </div>
            </div>
          </div>
        </div>

        <!-- Seção: Mensagens de Erro -->
        <div v-if="errors.length > 0" class="form-section">
          <ErrorsMessages :errors="errors" />
        </div>

        <!-- Seção: Ações -->
        <div class="form-actions">
          <div class="actions-grid">
            <v-btn
              class="btn-cancel-modern"
              @click="$bvModal.hide('createFolder')"
              :disabled="loading"
            >
              <i class="fas fa-times mr-2"></i>
              Cancelar
            </v-btn>
            <v-btn
              :disabled="loading"
              type="submit"
              class="btn-save-modern"
              @click="create"
            >
              <i class="fas fa-save mr-2"></i>
              {{ loading ? "Salvando..." : "Criar Pasta" }}
            </v-btn>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import ErrorsMessages from "../Components/ErrorsMessages.vue";
import LabelRequiredField from "../Components/LabelRequiredField";
import api from "../../services/api";
import toast from "../../lib/ToastNotification";

export default {
  name: "CreateFolder",
  components: {
    LabelRequiredField,
    ErrorsMessages,
  },

  data() {
    return {
      name: "",

      type_folder: "EMPRESA",

      link_folder: "USER",

      public_folder: 1,

      resident_id: null,

      residents: [],

      users: [],

      users_ids: [],

      profiles: [],

      profiles_ids: [],

      errors: [],

      loading: false,
    };
  },

  props: {
    selected_resident_id: Number,
  },

  watch: {
    public_folder() {
      this.errors = [];
    },

    type_folder() {
      this.errors = [];

      this.resident_id = null;
    },

    link_folder() {
      this.errors = [];

      this.users_ids = [];

      this.profiles_ids = [];
    },
  },

  mounted() {
    if (!this.selected_resident_id) {
      this.getResidents();
    }

    this.getUsers();

    this.getProfiles();
  },

  methods: {
    async create() {
      try {
        this.loading = true;

        let {
          name,
          type_folder,
          resident_id,
          public_folder,
          users_ids,
          link_folder,
          profiles_ids,
        } = this;

        if (this.selected_resident_id) {
          type_folder = "RESIDENTE";
          resident_id = this.selected_resident_id;
        }

        let params = {
          name,
          type_folder,
          resident_id,
          public_folder,
          users_ids,
          link_folder,
          profiles_ids,
        };

        const response = await api.post("/folder", params);

        const { error, errors, message } = response.data;

        if (!error) {
          this.$bvModal.hide("createFolder");

          this.name = "";

          this.errors = [];

          this.type_folder = "EMPRESA";

          toast(message, "success");

          this.$emit("create");
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.log(error);
      }
    },

    async getResidents() {
      try {
        this.loading = true;
        let params = { status_resident: "ATIVO" };
        const response = await api.get("/rest-home/residents", { params });
        const { error, residents } = response.data;

        if (!error) {
          this.residents = residents;
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.error(error);
      }
    },

    async getUsers() {
      try {
        this.loading = true;
        const response = await api.get("/rest-home/users");
        const { error, users } = response.data;

        if (!error) {
          this.users = users;
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.error(error);
      }
    },

    async getProfiles() {
      try {
        this.loading = true;

        const response = await api.get("/rest-home/profiles");

        const { error, profiles } = response.data;

        if (!error) {
          this.profiles = profiles;
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.error(error);
      }
    },

    resetFields() {
      this.name = "";

      this.type_folder = "EMPRESA";

      this.link_folder = "USER";

      this.resident_id = null;

      this.errors = [];

      this.users_ids = [];

      this.public_folder = 1;

      this.profiles_ids = [];

      // Foco no primeiro campo após um pequeno delay
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.$refs.nameInput) {
            this.$refs.nameInput.focus();
          }
        }, 100);
      });
    },

    closeSelectUser() {
      this.$refs.userSelect.blur();
    },

    closeSelectProfile() {
      this.$refs.profileSelect.blur();
    },
  },
};
</script>

<style scoped>
/* Modal Styling */
.modal-title-modern {
  display: flex;
  align-items: center;
  font-size: 20px;
  font-weight: 600;
  color: #1e293b;
}

.modal-title-modern i {
  color: #0f65b0;
}

.modal-content-modern {
  padding: 8px 0;
}

/* Form Sections */
.form-sections {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.form-section {
  background: #f8fafc;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  overflow: hidden;
  transition: all 0.3s ease;
}

.form-section:hover {
  border-color: #cbd5e1;
}

/* Section Headers */
.section-header {
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
  padding: 16px 20px;
  border-bottom: 1px solid #e5e7eb;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
  display: flex;
  align-items: center;
}

.section-title i {
  color: #0f65b0;
  font-size: 14px;
}

/* Section Content */
.section-content {
  padding: 20px;
}

/* Form Groups */
.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

/* Input Styling */
.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.input-icon {
  position: absolute;
  left: 12px;
  color: #6b7280;
  font-size: 14px;
  z-index: 1;
}

.modern-input {
  width: 100%;
  padding: 12px 16px 12px 40px;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.3s ease;
  background: white;
  color: #1e293b;
}

.modern-input:focus {
  border-color: #0f65b0;
  box-shadow: 0 0 0 3px rgba(15, 101, 176, 0.1);
  outline: none;
}

.modern-input::placeholder {
  color: #9ca3af;
}

/* Select Styling */
.select-wrapper {
  position: relative;
}

/* Toggle Buttons */
.toggle-group {
  display: flex;
  gap: 12px;
  justify-content: center;
  flex-wrap: wrap;
}

.toggle-btn {
  display: flex;
  align-items: center;
  background: white;
  color: #6b7280;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  padding: 14px 24px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 140px;
  justify-content: center;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.toggle-btn:hover:not(.active) {
  background: #f8fafc;
  border-color: #cbd5e1;
  color: #374151;
  transform: translateY(-1px);
}

.toggle-btn.active {
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%);
  color: white;
  border-color: #0f65b0;
  box-shadow: 0 4px 15px rgba(15, 101, 176, 0.3);
}

.toggle-btn.privacy-btn.active {
  background: linear-gradient(135deg, #059669 0%, #047857 100%);
  border-color: #059669;
  box-shadow: 0 4px 15px rgba(5, 150, 105, 0.3);
}

.toggle-btn i {
  font-size: 16px;
}

/* Form Hints */
.form-hint {
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #6b7280;
  margin-top: 4px;
  font-style: italic;
}

.form-hint i {
  color: #94a3b8;
  font-size: 11px;
}

/* Form Actions */
.form-actions {
  border-top: 2px solid #e5e7eb;
  padding: 24px 0 8px 0;
  margin-top: 8px;
}

.actions-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

/* Action Buttons */
.btn-cancel-modern {
  background: transparent !important;
  color: #6b7280 !important;
  border: 2px solid #e5e7eb !important;
  border-radius: 12px !important;
  padding: 14px 24px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05) !important;
  transition: all 0.3s ease !important;
}

.btn-cancel-modern:hover {
  background: #f8fafc !important;
  border-color: #cbd5e1 !important;
  color: #374151 !important;
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
}

.btn-save-modern {
  background: linear-gradient(135deg, #1e884d 0%, #16a34a 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 14px 24px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  box-shadow: 0 4px 15px rgba(30, 136, 77, 0.3) !important;
  transition: all 0.3s ease !important;
}

.btn-save-modern:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(30, 136, 77, 0.4) !important;
}

.btn-save-modern:disabled,
.btn-cancel-modern:disabled {
  opacity: 0.7 !important;
  cursor: not-allowed !important;
  transform: none !important;
}

/* Responsive Design */
@media (max-width: 768px) {
  .modal-content-modern {
    padding: 0;
  }

  .section-content {
    padding: 16px;
  }

  .section-header {
    padding: 12px 16px;
  }

  .toggle-group {
    flex-direction: column;
    gap: 8px;
  }

  .toggle-btn {
    min-width: auto;
    padding: 12px 20px;
  }

  .actions-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .btn-cancel-modern,
  .btn-save-modern {
    padding: 12px 20px !important;
  }
}

@media (max-width: 480px) {
  .section-title {
    font-size: 14px;
  }

  .modal-title-modern {
    font-size: 18px;
  }

  .toggle-btn {
    padding: 10px 16px;
    font-size: 13px;
  }

  .modern-input {
    padding: 10px 14px 10px 36px;
  }
}

/* Override Vuetify styles */
.modern-select >>> .v-input__control {
  border-radius: 8px !important;
}

.modern-select >>> .v-text-field__slot {
  background: white !important;
}

.modern-select >>> .v-input__slot {
  border: 2px solid #e5e7eb !important;
  border-radius: 8px !important;
  transition: all 0.3s ease !important;
}

.modern-select >>> .v-input__slot:hover {
  border-color: #cbd5e1 !important;
}

.modern-select >>> .v-input--is-focused .v-input__slot {
  border-color: #0f65b0 !important;
  box-shadow: 0 0 0 3px rgba(15, 101, 176, 0.1) !important;
}

.modern-select >>> .v-select__selection {
  color: #1e293b !important;
  font-weight: 500 !important;
}

/* Override Modal styles */
.modern-modal >>> .modal-header {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%) !important;
  border-bottom: 2px solid #e5e7eb !important;
  border-radius: 0 !important;
  padding: 20px 24px !important;
}

.modern-modal >>> .modal-body {
  padding: 24px !important;
  max-height: 70vh;
  overflow-y: auto;
}

.modern-modal >>> .modal-content {
  border: none !important;
  border-radius: 16px !important;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15) !important;
}

/* Scrollbar personalizada */
.modern-modal >>> .modal-body::-webkit-scrollbar {
  width: 6px;
}

.modern-modal >>> .modal-body::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 3px;
}

.modern-modal >>> .modal-body::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}

.modern-modal >>> .modal-body::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}
</style>